import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VbUiDurationInputComponent } from './VbUiDurationInput.Component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormGroupAngularModule } from '../formGroup/FormGroupAngular.Module';

const components = [
	VbUiDurationInputComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BsDropdownModule,
		CommonModule,
		FormGroupAngularModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule
	]
})
export class VbUiDurationInputAngularModule {}
